import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class UsersService {
    // 'Use-Virtual-Session' - used on SiteSetup (runs in VirtualSession)
    getLinkedUsers (virtualUserId, callback) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'users/getByVirtualUserId/' + virtualUserId, {
                headers: {
                    'Use-Virtual-Session': 'true'
                }
            });
    }

    // 'Use-Virtual-Session' - used on SiteSetup (runs in VirtualSession)
    unassign (userId) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'sso/user/unassign', { UserId: userId }, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    // 'Use-Virtual-Session' - used on SiteSetup (runs in VirtualSession)
    assign (loginUserRequest) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + 'sso/user/assign', loginUserRequest, {
            headers: {
                'Use-Virtual-Session': true
            },
            json: true
        });
    }

    // 'Use-Virtual-Session' - used on SiteSelector (runs in VirtualSession)
    getLinkedUsersByProduct(virtualUserId, virtualProductId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'users/getByVirtualUserId/' + virtualUserId + '/' + virtualProductId, {
                headers: {
                    'Use-Virtual-Session': 'true'
                }
            });
    }

    getUsersByOrgId (orgId, filter) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + 'users/getByOrgId/' + orgId, {
            params: filter
        });
    }
}

export default new UsersService();
